import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ShortInfoModalComponent } from '../short-info-modal/short-info-modal.component';
import { RecommendationModalAction, RecommendationModalComponent } from '../recommendation-modal/recommendation-modal.component';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import {
	defaultsToArticleOption,
	getAvailability,
	getBasePrice,
	getPrice,
	numberToCurrency,
	sleep
} from '../../../smoothr-web-app-core/utils/utils';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { filterMatchingOptions, OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { ValidationUtils } from '../../../smoothr-web-app-core/utils/validation-utils';
import { DisplayMode } from '../../../smoothr-web-app-core/enums/DisplayMode';
import { DisplayIdentifier } from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import FulfilledDependency from '../../../smoothr-web-app-core/models/FulfilledDependency';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { environment } from 'src/environments/environment';
import { PromoCodeType } from '../../../smoothr-web-app-core/models/PromoCodeType';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { shoGif } from '../item-view/item-view.component';
import { ShowRemoveIngrediantsDialogComponent } from '../show-remove-ingrediants-dialog/show-remove-ingrediants-dialog.component';
import { TracifyService } from '../../services/tracify.service';

@Component({
	selector: 'app-modal-info',
	templateUrl: './modal-info.component.html',
	styleUrls: ['modal-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalInfoComponent extends RepositoryDirective implements OnInit, AfterViewInit, DoCheck {
	@ViewChild('swiperInfo') slides: ElementRef | undefined;

	environment = environment;
	articleGroup: ArticleGroup;
	// false if coming from checkout
	recommend = true;
	OrderUtils = OrderUtils;
	validationUtils = ValidationUtils;
	showGif = shoGif.default;
	dm = DisplayMode;
	di = DisplayIdentifier;
	slideOpts = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false,
	};
	sliding = false;
	pages: OptionGroup[][] = [];
	optionGroupDependencies = {};
	currentPageIndex = 0;
	indicesOfRecommendations: number[] = [];
	isLastPage = false;
	numberToCurrency = numberToCurrency;
	getPrice = getPrice;
	getBasePrice = getBasePrice;
	filterMatchingOptions = filterMatchingOptions;
	checkIfButtonFinishedAvailable = false;
	extraToppingsTag = 'popup_rucola';


	ngDoCheck() {
		//console.log('View Checked');
	}

	constructor(
		public modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackBarCtrl: MatSnackBar,
		private translate: TranslateService,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private tracifyService: TracifyService
	) {
		super(repository);
	}

	get type(): PreorderType {
		return this.order.preorder.type;
	}

	ngOnInit() {
		super.ngOnInit();
		// Track product view when modal opens
		this.tracifyService.trackProductView();
		this.analytics.beginArticleEdit(this.articleGroup.article);
		const listGroups = this.articleGroup.article.groups.filter(
			group => !group.tags?.some(tag => tag.identifier === 'modifier_remove' || tag.identifier === this.extraToppingsTag)
		);

		// Group option groups into pages based on sortOrder (divided by 10)
		for (const group of listGroups) {
			const index = Math.floor(group.sortOrder / 10);
			if (this.pages[index] === undefined) {
				this.pages[index] = [];
			}
			this.pages[index].push(group);
		}

		if (this.pages.length === 0) {
			this.pages.push([]);
		}
		if (this.pages.length) {
			this.pages = this.pages.filter((page, i) => page !== null && this.pageVisible(i));
			this.pages.forEach((p) => {
				p.forEach((group: OptionGroup) => {
					group.dependency = ValidationUtils.isGroupDependencyFulfilled(
						this.articleGroup.article, this.articleGroup.groups, group);
				});
			});
		}

		// Sort option groups within each page by their sortOrder to ensure correct order
		for (const page of this.pages) {
			if (page && page.length > 0) {
				page.sort((a, b) => a.sortOrder - b.sortOrder);
			}
		}
		if (
			this.pages.length >= 1 &&
			this.pages[0].length === 1 &&
			(this.pages[0][0].displayMode === DisplayMode.DETAIL_OVERLAY || this.pages[0][0].sortOrder > 9)
		) {
			this.pages = [[], ...this.pages];
		}
		this.indicesOfRecommendations = [];
		this.pages.forEach((page, pageIndex) => {
			if (page.length > 0 && this.articleGroup.article.recommendations.find(recommendation => recommendation.group === page[0]._id)) {
				this.indicesOfRecommendations.push(pageIndex);
			}
		});

		this.onSlideChange();

		if (this.articleGroup?.article && this.articleGroup?.article?.number) {
			if (this.articleGroup?.article.number == '40144') {
				this.showGif = shoGif.buildOwn;
			}

			if (this.articleGroup?.article.number === '40002') {
				this.showGif = shoGif.ownSalate;
			}
		}
	}

	async ngAfterViewInit() {
		await this.slides?.nativeElement.swiper.isBeginning;
		console.log(this.pages);
		console.log(this.articleGroup);

		this.checkIfHaveGroups();
	}

	async finish() {
		// Validate all option groups before finishing
		if (!ValidationUtils.areGroupsValid(this.articleGroup, this.articleGroup.article.groups)) {
			this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'), null, {
				duration: 2000,
			});
			return;
		}

		this.analytics.finishArticleEdit(this.articleGroup.article, this.currentPageIndex);
		await this.modalCtrl.dismiss({
			articleGroup: this.articleGroup,
		});
	}

	async close() {
		this.analytics.cancelArticleEdit(this.articleGroup.article, this.currentPageIndex);
		await this.modalCtrl.dismiss();
	}

	increase() {
		this.articleGroup.quantity += 1;
	}

	decrease() {
		if (this.articleGroup.quantity > 1) {
			this.articleGroup.quantity -= 1;
		}
	}

	async addOverlayOption(pageIndex: number, optionIndex: number, optionArticle: Article, group: OptionGroup) {
		const option = new ArticleOption();
		option.article = optionArticle;
		option.quantity = 1;
		option.group = group._id;
		const fulfilledDependency = new FulfilledDependency();
		fulfilledDependency.dependency = null;
		fulfilledDependency.dependsOn = null;
		fulfilledDependency.times = 0;
		await this.addAndNext(pageIndex, optionIndex, option, group, fulfilledDependency);
	}

	async addAndNext(
		pageIndex: number,
		optionGroupIndex: number,
		option: ArticleOption,
		group: OptionGroup,
		fulfilledDependency: FulfilledDependency
	) {
		await this.add(pageIndex, optionGroupIndex, option, group, fulfilledDependency);
		this.cdr.detectChanges();
		await this.slides?.nativeElement?.swiper.update;

		await sleep(100);
		await this.nextSlide();
	}

	optionGroupDisabled(optionGroup: OptionGroup): boolean {
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && this.order.promoCode.type === PromoCodeType.BOGO) {
			const bogoArticleIndex = this.order.orderedArticles.findIndex(ag => ag.isPromo);
			const bogoArticle = this.order.orderedArticles[bogoArticleIndex];
			const matchingBogoArticleIndices = this.order.orderedArticles
				.map((ag, agIndex) => {
					return ag.article._id === bogoArticle.article._id &&
						!ag.isPromo &&
						OrderUtils.bogoPrice(ag, this.order.type, this.order.preorder.type) ===
							OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
						? agIndex
						: -1;
				})
				.filter(agIndex => agIndex !== -1);
			// article that should be removed is a possible parent of promoCode article
			if (
				matchingBogoArticleIndices.length === 1 &&
				bogoArticle.article._id === this.articleGroup.article._id &&
				OrderUtils.bogoPrice(this.articleGroup, this.order.type, this.order.preorder.type) ===
					OrderUtils.bogoPrice(bogoArticle, this.order.type, this.order.preorder.type)
			) {
				return !this.recommend;
			}
		}
		return this.articleGroup.isPromo && optionGroup.displayIdentifiers.indexOf(DisplayIdentifier.main) >= 0;
	}

	async add(
		pageIndex: number,
		optionGroupIndex: number,
		option: ArticleOption,
		group: OptionGroup,
		fulfilledDependency: FulfilledDependency,
		nextSlide: boolean = false
	) {
		if (this.sliding) {
			return;
		}

		// Check limit before adding the option (only for groups with multiple selections)
		const currentTotalInGroup = this.articleGroup.groups
			.filter(addedOption => group._id === addedOption.group)
			.reduce((prev, curr) => prev + curr.quantity, 0);

		const isRemoval = option.quantity < 0;

		// For groups with multiple selection, enforce the limit BEFORE adding (but NOT for removals)
		if (group.hasMultiple && !isRemoval && group.limit > 0 && currentTotalInGroup >= group.limit) {
			return;
		}

		// Core functionality: Add the selected option to the article group
		// This handles the business logic of adding checkbox selections to the order
		OrderUtils.addOption(this.articleGroup.groups, option, group, fulfilledDependency);

		// Re-apply defaults whose dependencies may now be fulfilled after this selection
		this.applyDependencyDefaults();

		const slideIndex = await this.slides?.nativeElement.swiper.activeIndex;

		try {
			// Auto-scroll to next unselected option on the same page
			await this.scrollToNextUnselectedOption(pageIndex, optionGroupIndex);
		} catch (e) {
			// Error Handling: Log scroll failures for debugging
			// Previously this would crash the entire component
			// Now it gracefully logs the error and continues execution
			console.error({
				pageIndex,
				message: 'could not scroll to next option',
				e,
			});
		}

		try {
			// Removed automatic addToOrder() call when selecting required options
			// Users must now explicitly click the add to cart button

			// DOM Safety Fix: Safely traverse DOM structure with comprehensive null checks
			// This prevents "Cannot read properties of undefined (reading 'children')" errors
			// that occurred when the expected DOM structure wasn't available
			const slidesEl = this.slides?.nativeElement;
			// Level 1: Check slides element and its children
			if (!slidesEl || !slidesEl.children || !slidesEl.children[0]) {
				return;
			}

			// Level 2: Check slide container and current slide
			const slideContainer = slidesEl.children[0];
			if (!slideContainer.children || !slideContainer.children[slideIndex]) {
				return;
			}

			// Level 3: Check slide content structure (deeply nested DOM)
			const slide = slideContainer.children[slideIndex];
			if (!slide.children || !slide.children[0] || !slide.children[0].children || !slide.children[0].children[1]) {
				return;
			}

			// Level 4: Get the final container that holds the options
			const container = slide.children[0].children[1];
			if (!container || !container.children) {
				return;
			}

			const options: HTMLCollection = container.children;
			const previousNotFulfilledOptions = this.pages[pageIndex]
				.map(
					(optionGroup, index) =>
						index < optionGroupIndex &&
						ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, this.articleGroup.groups, optionGroup).times <
							0
				)
				.filter(res => res).length;
			if (options.length - 1 < optionGroupIndex + 2 - previousNotFulfilledOptions) {
				return;
			}

			// options[optionGroupIndex + 2 - previousNotFulfilledOptions].scrollIntoView({ behavior: 'smooth' });
		} catch (e) {
			// Error Handling: Log scroll failures for debugging
			// Previously this would crash the entire component
			// Now it gracefully logs the error and continues execution
			console.error({
				pageIndex,
				message: 'could not scroll',
				e,
			});
		}
	}

	// Re-apply defaults based on current dependency fulfillment state
	// Adds defaults whose dependencies are now fulfilled and removes those whose dependencies are no longer fulfilled
	private applyDependencyDefaults(): void {
		if (!this.articleGroup.article.defaults || this.articleGroup.article.defaults.length === 0) {
			return;
		}

		// First, remove any applied defaults whose dependencies are no longer fulfilled
		for (const def of this.articleGroup.article.defaults) {
			const group = this.articleGroup.article.groups?.find(grp => grp._id === def.group);
			if (!group) {
				continue;
			}

			const appliedOption = this.articleGroup.groups.find(
				opt => opt.group === def.group && opt.article._id === def.article
			);

			if (appliedOption) {
				// Check if dependency is still fulfilled
				const dependency = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, this.articleGroup.groups, group);

				// If dependency is no longer fulfilled (or is fulfilled by a different option), remove the default
				if (dependency.times < 0 || (dependency.dependsOn && appliedOption.dependsOn !== dependency.dependsOn)) {
					// Find and remove the applied default
					const removeIndex = this.articleGroup.groups.findIndex(
						opt => opt.group === def.group && opt.article._id === def.article
					);
					if (removeIndex >= 0) {
						this.articleGroup.groups.splice(removeIndex, 1);
						console.log('Removed dependency default:', appliedOption.article.name?.de || def.article);
					}
				}
			}
		}

		// Then, add defaults whose dependencies are now fulfilled
		for (const def of this.articleGroup.article.defaults) {
			// Skip if this default is already in the selected options
			const alreadyApplied = this.articleGroup.groups.find(
				opt => opt.group === def.group && opt.article._id === def.article
			);
			if (alreadyApplied) {
				continue;
			}

			const group = this.articleGroup.article.groups?.find(grp => grp._id === def.group);
			if (!group) {
				continue;
			}

			// Check if dependency is now fulfilled (only for defaults with dependencies)
			const dependency = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, this.articleGroup.groups, group);
			if (dependency.times > 0) {
				// Apply the default
				const defaultOption = new ArticleOption();
				defaultOption.group = def.group;
				defaultOption.quantity = def.quantity;
				defaultOption.article = group.articles?.find(art => art._id === def.article);
				if (defaultOption.article) {
					defaultOption.dependsOn = dependency.dependsOn ?? null;
					defaultOption.dependencyNumber = dependency.times;
					defaultOption.dependency = dependency.dependency?._id ?? null;
					OrderUtils.addOption(this.articleGroup.groups, defaultOption, group, dependency);
					console.log('Applied dependency default:', defaultOption.article.name?.de || def.article);
				}
			}
		}
	}

	async scrollToNextUnselectedOption(pageIndex: number, optionGroupIndex: number) {
		// Wait for DOM to update after selection
		await sleep(100);

		// Find the next option group on the same page to scroll to
		const currentPage = this.pages[pageIndex];
		let nextOptionGroupIndex = -1;

		for (let i = optionGroupIndex + 1; i < currentPage.length; i++) {
			const optionGroup = currentPage[i];
			const dependency = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, this.articleGroup.groups, optionGroup);			

			// Check if this option group is visible and has available options
			if (dependency.times >= 0 || this.isSharedOptionGroup(optionGroup)) {
				// Check if this option group has selectable (visible) articles
				const hasVisibleArticles =
					optionGroup.articles && optionGroup.articles.some(article => !article.hidden && this.isArticleAvailable());

				if (hasVisibleArticles) {
					nextOptionGroupIndex = i;
					break;
				}
			}
		}
		//TODO: hot fix
		// If we found a next option group, scroll to it
		if (nextOptionGroupIndex !== -1) {
			console.log(`Scrolling to next option group: ${nextOptionGroupIndex} on page ${pageIndex}`);
			await this.scrollToOptionGroup(pageIndex, nextOptionGroupIndex);
		}
	}

	private isArticleAvailable(): boolean {
		// Check if article is available based on preorder type
		return true; // Simplified for now, you can add availability logic here if needed
	}

	async scrollToOptionGroup(pageIndex: number, optionGroupIndex: number) {
		// Wait for DOM to update after selection
		await sleep(100);

		// Simple approach: look for option group descriptions on the current page
		const optionGroupEl = document.getElementById('group-description-id-' + pageIndex + '-' + optionGroupIndex);

		if (optionGroupEl) {
			optionGroupEl.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	}


	async pageIndex(): Promise<number> {
		await sleep(100);
		let activeIndex = this.slides?.nativeElement?.swiper?.activeIndex;
		const activeIndexValue = activeIndex + this.hiddenCount(activeIndex);
		return activeIndexValue;
	}

	hiddenCount(until: number): number {
		let realIndex = until;
		this.indicesOfRecommendations.forEach(index => {
			if (realIndex >= index) {
				realIndex = realIndex + 1;
			}
		});
		return this.articleGroup.isRecommendedRecipe
			? this.indicesOfRecommendations
					.map(index => (index <= realIndex ? 1 : 0))
					.reduce((previousValue, currentValue) => previousValue + currentValue, 0)
			: 0;
	}

	async addToOrder() {
		if (
			this.currentPageIndex === 0 &&
			this.recommend &&
			this.articleGroup.article.recommendations &&
			this.articleGroup.article.recommendations.length > 0 &&
			ValidationUtils.areGroupsValid(this.articleGroup, [])
		) {
			const recommendations = defaultsToArticleOption(
				this.articleGroup.article,
				this.articleGroup.groups,
				this.articleGroup.article.recommendations,
				OrderType.PREORDER,
				this.order.preorder.type
			);
			const groups: OptionGroup[] = [];
			this.articleGroup.article.recommendations.forEach(option => {
				const insertedGrp = groups.find(grp => grp._id === option.group);
				if (!insertedGrp) {
					const group = this.articleGroup.article.groups.find(grp => option.group === grp._id);
					// only fulfilled recommendations are relevant
					if (ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, recommendations, group).times >= 0) {
						groups.push(this.articleGroup.article.groups.find(grp => option.group === grp._id));
					}
				}
			});
			// Check if some recommendations are inactive before we allow the user to select recommendations
			const allRequiredAvailable = groups
				.map(grp => recommendations.filter(opt => opt.group === grp._id).length)
				.map((value, index) => groups[index].requiredAmount <= value)
				.reduce((previousValue, currentValue) => previousValue && currentValue, true);
			const recommendationAction = allRequiredAvailable
				? await RecommendationModalComponent.show(this.modalCtrl)
				: RecommendationModalAction.CUSTOMIZATION;
			switch (recommendationAction) {
				case RecommendationModalAction.CUSTOMIZATION:
					this.articleGroup.isRecommendedRecipe = false;
					await sleep(100);
					if (!(await this.slides?.nativeElement.swiper.isEnd)) {
						await this.nextSlide();

						return;
					}
					if (!ValidationUtils.areGroupsValid(this.articleGroup, this.articleGroup.article.groups)) {
						this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'));
						return;
					}
					await this.finish();
					return;
				case RecommendationModalAction.DISMISS:
					return;
				case RecommendationModalAction.RECOMMENDATION:
					this.articleGroup.isRecommendedRecipe = true;
					await sleep(100);
					// filter options of first page
					const optionsToKeep = [
						...this.articleGroup.groups.filter(
							option => this.pages[0].findIndex(optionGroup => optionGroup._id === option.group) >= 0
						),
						...recommendations,
					];
					this.articleGroup.groups = [];
					optionsToKeep.forEach(opt => {
						const grp = this.articleGroup.article.groups.find(group => group._id === opt.group);
						const dep = ValidationUtils.isGroupDependencyFulfilled(this.articleGroup.article, optionsToKeep, grp);
						OrderUtils.addOption(this.articleGroup.groups, opt, grp, dep);
					});
					await this.nextSlide();
					return;
				default:
					return;
			}
		} else {
			if (this.articleGroup.isRecommendedRecipe) {
				for (const recommendationIndex of this.indicesOfRecommendations) {
					const page = this.pages[recommendationIndex].map(group => group._id);
					this.articleGroup.groups = this.articleGroup.groups.filter(opt => page.indexOf(opt.group) < 0);
				}
				this.articleGroup.groups = defaultsToArticleOption(
					this.articleGroup.article,
					this.articleGroup.groups,
					this.articleGroup.article.recommendations,
					OrderType.PREORDER,
					this.order.preorder.type
				);
			}
			if (!(await this.slides?.nativeElement?.swiper?.isEnd)) {
				await this.nextSlide();
				return;
			}
			if (!ValidationUtils.areGroupsValid(this.articleGroup, this.articleGroup.article.groups)) {
				this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'), null, {
					duration: 2000,
				});
				return;
			}
			await this.finish();
		}
	}

	async onSlideChange() {
		const pageIndex = await this.pageIndex();
		this.currentPageIndex = pageIndex;
		this.isLastPage = await this.slides?.nativeElement.swiper.isEnd;

		console.log({
			// slideIndex,
			index: pageIndex,
			lastPage: this.isLastPage,
			pages: this.pages.map(page => page.map(grp => grp.name.de)),
			modes: this.pages.map(page => page.map(grp => grp.displayMode)),
		});
	}

	async prevSlide() {
		if (this.sliding) {
			return;
		}
		if (await this.slides?.nativeElement?.swiper?.isBeginning) {
			this.close();
		}
		this.sliding = true;
		if (!(await this.slides?.nativeElement?.swiper?.isBeginning)) {
			await this.slides?.nativeElement?.swiper.slidePrev(500);
		}
		this.sliding = false;
	}

	async nextSlide() {
		if (this.sliding) {
			return;
		}

		this.sliding = true;
		if (await this.slides?.nativeElement.swiper.isEnd) {
			await this.addToOrder();
			return;
		}
		await this.validateAndSlideNext(this.pages[await this.pageIndex()]);
	}

	async validateAndSlideNext(optionGroups: OptionGroup[]) {
		const pageValid = ValidationUtils.areGroupsValid(this.articleGroup, optionGroups);
		if (!pageValid) {
			this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'));
			this.sliding = false;
			return;
		}
		if (await this.slides?.nativeElement?.swiper.isEnd) {
			await this.addToOrder();
		} else {
			this.analytics.stepArticleEdit(this.articleGroup.article, this.currentPageIndex);
			await this.slides.nativeElement?.swiper.update();
			await this.slides?.nativeElement?.swiper.slideNext(500);
		}
		this.sliding = false;
	}

	async closeSlide() {
		console.log(this.sliding);
		if (this.sliding) {
			return;
		}
		this.sliding = true;
		await this.slides.nativeElement?.swiper.update();
		await this.slides.nativeElement?.swiper.slideTo(0);
		this.sliding = false;
	}

	async openInfo(article: Article) {
		await ShortInfoModalComponent.show(this.modalCtrl, article.info);
	}

	currentPage(): OptionGroup {
		return this.pages[this.currentPageIndex][0];
	}

	nextFulfilledPage(currentPage: number): number {
		return this.pages.findIndex(
			(groups, index) => index > currentPage && ValidationUtils.someGroupsFulfilled(this.articleGroup, groups)
		);
	}

	previousFulfilledPage(currentPage: number): number {
		return Math.max(
			...this.pages.map((page, index) => {
				if (index < currentPage && ValidationUtils.someGroupsFulfilled(this.articleGroup, page)) {
					return index;
				} else {
					return 0;
				}
			})
		);
	}

	async clearCurrentPageAndNext(pageIndex) {
		this.articleGroup.groups = this.articleGroup.groups.filter(option => {
			for (const grp of this.pages[pageIndex]) {
				if (option.group === grp._id) {
					return false;
				}
			}
			return true;
		});
		await this.nextSlide();
	}

	async requireOneOfAndNextSlide(pageIndex) {
		const currentPageArticles = this.articleGroup.groups.filter(option => {
			for (const grp of this.pages[pageIndex]) {
				if (option.group === grp._id) {
					return true;
				}
			}
			return false;
		});
		if (currentPageArticles.length === 0) {
			this.snackBarCtrl.open(this.translate.instant('modal_info.pick_error'));
			return;
		}
		await this.nextSlide();
	}

	pageVisible(pageIndex: number): boolean {
		// Some pages needs to be invisible (if dependencies are not fulfilled or recommendations taken)

		return (
			(((!this.articleGroup.isRecommendedRecipe || this.indicesOfRecommendations.indexOf(pageIndex) < 0) &&
					ValidationUtils.someGroupsFulfilled(this.articleGroup, this.pages[pageIndex])) ||
				!ValidationUtils.areGroupsValid(this.articleGroup, this.pages[pageIndex])) &&
			(pageIndex > 0
				? !!this.pages[pageIndex].find(it => it.visible) &&
				!!this.pages[pageIndex][0]?.articles?.find(
					it => it?.visible && getAvailability(it, OrderType.PREORDER, this.order.preorder.type)
				)
				: true)
		);
	}

	// isPageOverlay(pageIndex: number): boolean {
	// 	return pageIndex !== 0 && this.pages[pageIndex][0].displayMode !== DisplayMode.DETAIL_OVERLAY;
	// }
	checkPageIfHaveGrid(articleGroup: ArticleGroup) {
		return (
			articleGroup.article.groups.length > 0 &&
			articleGroup.article.groups.filter(it => !!it.tags.find(tag => tag.identifier === 'half_pizza')).length > 0
		);
		// return articleGroup.article.tags.find(it => it.identifier == 'half_pizza');
	}
	checkIfLandscape(src: string) {
		const image = new Image();
		image.src = src;
		var height = image.height;
		var width = image.width;

		if (width > height + 100) {
			return true;
		}
	}
	checkIfHaveGroups() {
		this.checkIfButtonFinishedAvailable =
			this.articleGroup.article.groups.length > 0 &&
			!this.articleGroup.article.tags.find(it => it?.identifier?.includes('deposit')) &&
			this.articleGroup.article.groups.filter(it => it.requiredAmount > 0 && it.visible)?.length === 0;
	}

	get hasNextPageGroups(): boolean {
		return (
			this.articleGroup?.article?.groups
				?.filter(group => !group.tags?.some(tag => tag.identifier === this.extraToppingsTag))
				?.some(group => group.sortOrder > 10 && group.visible === true) || false
		);
	}
	checkIfOwnPizza(article: Article) {
		return article?.number == '40144';
	}
	checkTag(optionGroup: OptionGroup) {
		return optionGroup && optionGroup.tags.length > 0 && optionGroup.tags.find(it => it?.identifier === 'with_bread');
	}
	addCustomOption(optionGroup: OptionGroup, pageIndex: number, optionGroupIndex: number, dependency: FulfilledDependency) {
		const foundArticle = optionGroup.articles.find(it => it.visible);
		if (foundArticle) {
			const articleOption = new ArticleOption();
			articleOption.article = foundArticle;
			articleOption.group = optionGroup._id;
			articleOption.quantity = 1;
			this.add(pageIndex, optionGroupIndex, articleOption, optionGroup, dependency);
		}
	}
	checkOptionGroup(optionGroups: OptionGroup[]) {
		return optionGroups.find(op => !!op.tags.find(it => it.identifier == 'modifier_remove'));
	}
	async openRemoveIngredients(optionGroups: OptionGroup[]) {
		console.log('artG', this.articleGroup);
		const foundGroupWithRemoving = optionGroups.find(op => !!op.tags.find(it => it.identifier == 'modifier_remove'));
		if (!foundGroupWithRemoving) {
			return;
		}
		const result = await ShowRemoveIngrediantsDialogComponent.show(
			this.modalCtrl,
			foundGroupWithRemoving,
			this.articleGroup,
			this.order
		);
		console.log(result);
		if (result && result.data && result.data.length > 0) {
			for (const opt of result.data) {
				const fulfilledDependency = new FulfilledDependency();
				fulfilledDependency.dependency = null;
				fulfilledDependency.dependsOn = null;
				fulfilledDependency.times = 0;
				await this.add(0, 0, opt, foundGroupWithRemoving, fulfilledDependency, false);
			}
			this.cdr.markForCheck();
		}
	}

	isSharedOptionGroup(optionGroup: OptionGroup): boolean {
		// Get all currently selected article IDs
		const selectedArticleIds = this.articleGroup.groups.map(selectedOption => selectedOption.article._id);

		if (selectedArticleIds.length === 0) {
			return false;
		}

		// Check if the option group has dependencies that reference any selected articles
		const dependencies = this.articleGroup.article.groupDependencies.filter(dep => dep.group === optionGroup._id);

		for (const dependency of dependencies) {
			for (const depGroup of dependency.dependencies) {
				const hasMatchingSelection = depGroup.groupArticles.some(articleId => selectedArticleIds.includes(articleId));
				if (hasMatchingSelection) {
					return true;
				}
			}
		}

		return false;
	}
}
